import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../login/services/authentication.service';
import { map } from 'rxjs/operators';
import { SnackbarService } from '../../core/services/snackbar.service';
import { User } from '../../core/models/user.model';

@Injectable()
export class TokenResolver implements Resolve<User> {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackbarService: SnackbarService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    const token = route.queryParamMap.get('token');
    // TODO token présent et pas déjà authent
    if (!!token) {
      return this.authenticationService.tokenLogin(token).pipe(
        map((user: User) => {
          if (!!user) {
            // If user is not attached to a badge redirect to badge login.
            // if (!user.badge) {
            //   this.router.navigate(['/login/badge']);
            //   return null;
            // }

            if (!user.isInformationConfirmed) {
              this.router.navigate(['/user/profile']);
            }

            return user;
          } else {
            this.snackbarService.addMessage('Sorry we\'re not be able to authenticate you. Please contact an administrator.');
            this.router.navigate(['/login']);
            return null;
          }
        })
      );
    }
  }
}
